import { sumBy } from 'lodash';
import styled from 'styled-components/macro';
import { DataForDesignDrawingsManifold } from '../../designs/data-for-design-drawings/dataForDesignDrawingsResponse';
import { ManifoldDiagram, MIDDLE_PATH_DETAILS, SVG_TRANSFORM, BRACKET_SIZE } from './ManifoldDiagram';
import { ManifoldDiagramBottomTable } from './ManifoldDiagramBottomTable';
import { ManifoldDiagramTopTable } from './ManifoldDiagramTopTable';
import { Svg } from '../../../shared/Svg';

const MANIFOLD_WIDTH = 1500;
const DIAGRAM_HEIGHT = 768;
const LEFT_DIAGRAM_WIDTH_TO_TAP = 168;
const TH_HORIZONTAL_PADDING = 2;
const TH_BORDER_SIZE = 1;
const COLUMN_WIDTH =
  MIDDLE_PATH_DETAILS.actuatorDefaultWidth * SVG_TRANSFORM.scale - 2 * TH_HORIZONTAL_PADDING - TH_BORDER_SIZE;

export const ACTUATOR_WIDTH_INCLUDING_BRACKET = 2 * BRACKET_SIZE * SVG_TRANSFORM.scale + COLUMN_WIDTH;

const PORTS_ROW_WIDTHS = {
  firstColumnWidth: LEFT_DIAGRAM_WIDTH_TO_TAP,
  firstActuatorColumnWidth: ACTUATOR_WIDTH_INCLUDING_BRACKET,
  actuatorColumnWidth: COLUMN_WIDTH,
};

type Props = {
  manifold: DataForDesignDrawingsManifold;
};
export const ManifoldDiagramWithTable = ({ manifold }: Props) => {
  const numberOfPorts = sumBy(manifold.rooms, room => room.numberOfPorts);

  return (
    <DiagramContainer>
      <StyledManifoldDiagramTopTable
        manifold={manifold}
        numberOfPorts={numberOfPorts}
        portsRowWidths={PORTS_ROW_WIDTHS}
      />
      <Svg height={DIAGRAM_HEIGHT} width={MANIFOLD_WIDTH}>
        <ManifoldDiagram manifold={manifold} key={manifold.manifoldId} />
      </Svg>
      <StyledManifoldDiagramBottomTable
        manifold={manifold}
        numberOfPorts={numberOfPorts}
        portsRowWidths={PORTS_ROW_WIDTHS}
      />
    </DiagramContainer>
  );
};

const DiagramContainer = styled.div`
  margin-left: 100px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: flex-start;
`;

export const ManifoldDiagramTable = styled.table`
  border: 1px solid black;
  border-collapse: collapse;
  table-layout: fixed;
  padding: 0;

  th,
  td {
    text-align: center;
    padding: ${TH_HORIZONTAL_PADDING}px;
    border: ${TH_BORDER_SIZE}px solid black;
    border-collapse: collapse;
  }
  th {
    font-weight: bold;
  }

  td {
    overflow-wrap: anywhere;
  }
`;

const tableXAlignment = 180;

const StyledManifoldDiagramTopTable = styled(ManifoldDiagramTopTable)`
  margin-left: ${tableXAlignment}px;
`;

const StyledManifoldDiagramBottomTable = styled(ManifoldDiagramBottomTable)`
  margin-left: ${tableXAlignment}px;
`;
